import {Injectable} from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AlertMessageService, i18nService} from 'jrz-common';
import {HttpErrorAdapter} from './http-error';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {

    constructor(private alertMessageService: AlertMessageService,
                private httpErrorAdapter: HttpErrorAdapter,
                private i18nService: i18nService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((response: HttpErrorResponse) => {
                this.handleError(response);
                return throwError(this.httpErrorAdapter.adapt(response.error))
            }));
    }

    private handleError(response: HttpErrorResponse) {
        if (!response) {
            return;
        }
        
        switch (response.status) {
            case 400:
                this.alertMessageService.showErrorMessage(this.i18nService.getMessage('web.general.message.bad_request'));
                break;
            case 403:
                this.alertMessageService.showWarnMessage(this.i18nService.getMessage('web.general.message.user_not_loggedin'));
                break;
            case 404:
                break;
            case 500:
                this.alertMessageService.showErrorMessage(this.i18nService.getMessage('web.general.message.unknown_error'));
                break;
            case 503:
                this.alertMessageService.showErrorMessage(this.i18nService.getMessage('web.general.message.server_unavailable'));
                break;
            default:
        }
    }
}
